export type ChannelType = 'keito_nai' | 'keito_gai'

export interface BreedingManager {
  id: string
  displayName: string
  channelType: ChannelType
  addressShort?: string | null
  selfServiceEnabled?: boolean
}

export interface BreedingManagerCandidate extends BreedingManager {
  matchReason: 'nlbc_mapping' | 'display_name_partial'
  score: number
}

export interface CattleSearchInfo {
  farmer?: string | null
  birthday?: string | null
  sex?: string | null
}

export interface PredictionInspectResponse {
  cattleId: string
  originalCattleId: string
  cattleIdOverridden: boolean
  shotAt: string
  cattleSearch: CattleSearchInfo | null
  breedingCandidates: BreedingManagerCandidate[]
}

interface BreedingManagerCandidateApiResponse {
  id: string
  displayName: string
  channelType: ChannelType
  addressShort?: string | null
  matchReason: BreedingManagerCandidate['matchReason']
  score: number
}

/* inspect API は snake_case のため camelcase をこのブロックのみ無効化 */
/* eslint-disable camelcase */
interface PredictionInspectApiResponse {
  cattle_id: string
  original_cattle_id?: string
  cattle_id_overridden?: boolean
  shot_at: string
  cattle_search: CattleSearchInfo | null
  breeding_candidates?: BreedingManagerCandidateApiResponse[] | null
}

export function parsePredictionInspectResponse(
  data: PredictionInspectApiResponse,
): PredictionInspectResponse {
  return {
    cattleId: data.cattle_id,
    originalCattleId: data.original_cattle_id ?? data.cattle_id,
    cattleIdOverridden: data.cattle_id_overridden ?? false,
    shotAt: data.shot_at,
    cattleSearch: data.cattle_search,
    breedingCandidates: (data.breeding_candidates ?? []).map((candidate) => ({
      id: candidate.id,
      displayName: candidate.displayName,
      channelType: candidate.channelType,
      addressShort: candidate.addressShort,
      matchReason: candidate.matchReason,
      score: candidate.score,
    })),
  }
}
/* eslint-enable camelcase */

export interface PredictionBreedingManagerInfo {
  breedingManager: BreedingManager
  confirmedAt?: string
  confirmedByUserId?: string
}

export const channelTypeLabel: Record<ChannelType, string> = {
  keito_nai: '系統内',
  keito_gai: '系統外',
}
